import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const OPEN_PATHS = ["/abonnement", "/cadeaux"];

// Sans essai actif ni achat, tout renvoie vers la page d'abonnement.
export default function AccessGate({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const status = user?.access?.status;

  if (!user || status !== "expired") return children;
  if (OPEN_PATHS.some((p) => pathname.startsWith(p))) return children;
  return <Navigate to="/abonnement" replace />;
}
